const Body = ({ children }) => {
  return <main className="container">{children}</main>
}

export default Body
